<template>
  <div class="row items-center" :class="margin">
    <q-separator class="col" />
    <div class="q-px-sm text-center text-grey">{{ text }}</div>
    <q-separator class="col" />
  </div>
</template>

<script setup>
defineProps({
  text: {
    type: String,
    default: ""
  },
  margin: {
    type: String,
    default: "q-my-md"
  }
});
</script>

<style scoped></style>
